/** Mirror backend period_to_range (UTC, week starts Monday). */
export function periodToIsoRange(period) {
  const now = new Date();
  const end = now.toISOString().slice(0, 10);
  let start = new Date(now);

  if (period === 'this_week') {
    const day = now.getUTCDay();
    const diff = day === 0 ? 6 : day - 1;
    start.setUTCDate(now.getUTCDate() - diff);
  } else if (period === 'this_month') {
    start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  } else {
    start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  }

  const from = start.toISOString().slice(0, 10);
  return { from, to: end };
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysIso(iso, days) {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/** Single calendar day in the past. */
export function dayRange(iso) {
  return { from: iso, to: iso };
}

export function yesterdayRange() {
  const y = addDaysIso(todayIso(), -1);
  return dayRange(y);
}

/** Last N days ending yesterday (excludes today). */
export function lastDaysEndingYesterday(n) {
  const to = addDaysIso(todayIso(), -1);
  const from = addDaysIso(todayIso(), -n);
  return { from, to };
}

export const HISTORICAL_PRESETS = [
  { id: 'yesterday', label: 'Yesterday', range: yesterdayRange },
  { id: 'last7', label: 'Last 7 days', range: () => lastDaysEndingYesterday(7) },
  { id: 'last30', label: 'Last 30 days', range: () => lastDaysEndingYesterday(30) },
];
